import { Module } from 'vuex';
import { IRootState } from './store';
import restService from '@/services/restService';
import userStore from './user-store';

export interface IAdminState {
  users: IUser[];
  shares: IShare[];
}

const adminState: IAdminState = {
  users: [],
  shares: [],
};

const adminGetters = {
  allUsers: (state: IAdminState) => state.users,
  getShares: (state: IAdminState) => (id: number) => {
    const shares = state.shares;
    const share = shares.find(s => {
      const idTonumber = +id;
      return s.id === idTonumber;
    });
    return share;
  },
  userDetails: (state: IAdminState) => (id: string) => {
    const user = state.users.find((u: IUser) => u.id === id);
    return user;
  },
  getShare: (state: IAdminState) => (id: number) => state.shares.find(s => s.id === id)
};

const adminMutations = {
  setUsers: (state: IAdminState, users: IUser[]) => state.users = users
    .filter(u => u.name)
    .sort((a, b) => a.name.localeCompare(b.name)),

  setShares: (state: IAdminState, shares: IShare[]) => state.shares = shares,
  addUser: (state: IAdminState, user: IUser) => state.users.push(user),
  updateUser: (state: IAdminState, user: IUser) =>
    state.users.splice(state.users.findIndex(u => u.id === user.id), 1, user),
  cancelShareMembership: (state: IAdminState, cancelledMembership: IMember) => {
    const share = state.shares.find(s => s.id === cancelledMembership.shareNumber);
    if (share) {
      share.memberEmail = '';
      share.memberName = '';
    }
  },
  addShareMembership: (state: IAdminState, addedMembership: IMember) => {
    const share = state.shares.find(s => s.id === addedMembership.shareNumber);
    if (share) {
      share.memberEmail = addedMembership.email;
      share.memberName = addedMembership.name;
    }
  }
};

const adminActions = {
  async getShares({ commit }: { commit: any }) {
    commit('app/setLoading', true, {root: true});
    const shares = await restService.shares.getShares();
    commit('setShares', shares);
    commit('app/setLoading', false, {root: true});
  },
  async getUsers({ commit }: { commit: any}  ) {
    const users = await restService.users.getUsers();
    commit('setUsers', users);
  },
};

const adminStore: Module<IAdminState, IRootState> = {
  namespaced: true,
  state: adminState,
  getters: adminGetters,
  actions: adminActions,
  mutations: adminMutations,
};
export default adminStore;
